import { Bell } from 'lucide-react';
import Link from 'next/link';
import { cn } from 'utils';

import { Icon } from 'components/common';
import BatteryStatus from 'components/complex/battery-status/BatteryStatus';
import { STypography } from 'components/ui';

import { useNewNotificationIndicator } from 'hooks/useNewNotificationIndicator';

import { useDeviceName, useRobotId } from 'lib/api/myRobot';

import { SCurrentRobotName } from '../styled';

const SidebarRobotInfo = () => {
  const { deviceName } = useDeviceName();
  const { robotId } = useRobotId();
  const { newNotificationIndicator, resetNotificationIndicator } = useNewNotificationIndicator();

  return (
    <SCurrentRobotName data-testid="sidebar-robot-info">
      <Icon icon="robot_head" />
      <STypography truncate>{deviceName}</STypography>
      <BatteryStatus />
      <Link
        href={`/${robotId}/overview/notifications`}
        className="relative"
        onClick={() => newNotificationIndicator && resetNotificationIndicator()}
      >
        <Bell className={cn('w-4 h-4', newNotificationIndicator && 'stroke-yellow-500')} />
        {newNotificationIndicator && (
          <span className="bg-destructive absolute -top-1 -right-1 rounded-full size-2 "></span>
        )}
      </Link>
    </SCurrentRobotName>
  );
};

export default SidebarRobotInfo;
